import React, { useState } from "react";
import { API } from "aws-amplify";
import Box from "@material-ui/core/Box";

export default function EmailSignResend() {
    const [ownerId, setOwnerId] = useState("");
    const [tranId, setTranId] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("ownerId:", ownerId);
        console.log("tranId:", tranId);
        const content = { metadata: { ownerId, tranId } }
        doResend(content);
    };
    async function doResend(content) {
        const result = await resendSignToSignMaker(content);
        alert(JSON.stringify(result,2));
    }

    function resendSignToSignMaker(content) {
        return API.post("aires", "/payments", {
            body: { type: 'resendShopOrder', content }
        });
    }

    return (
        <Box mt={5} mx={2} display="flex" justifyContent="center" width="100%">
            <div style={styles.box}>
                <h2 style={styles.heading}>Resend Signage Order</h2>

                <form onSubmit={handleSubmit} style={styles.form}>
                    <label style={styles.label}>
                        Owner ID
                        <input
                            type="text"
                            value={ownerId}
                            onChange={(e) => setOwnerId(e.target.value)}
                            style={styles.input}
                            placeholder="Enter ownerId"
                        />
                    </label>

                    <label style={styles.label}>
                        Transaction ID
                        <input
                            type="text"
                            value={tranId}
                            onChange={(e) => setTranId(e.target.value)}
                            style={styles.input}
                            placeholder="Enter tranId"
                        />
                    </label>

                    <button type="submit" style={styles.button}>
                        Submit
                    </button>
                </form>
            </div>
        </Box>
    );
}

const styles = {
    box: {
        maxWidth: "400px",
        padding: "20px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#fff",
    },
    heading: {
        marginTop: 0,
        marginBottom: "16px",
    },
    form: {
        display: "flex",
        flexDirection: "column",
        gap: "12px",
    },
    label: {
        display: "flex",
        flexDirection: "column",
        fontSize: "14px",
        fontWeight: "500",
    },
    input: {
        marginTop: "6px",
        padding: "8px",
        fontSize: "14px",
        border: "1px solid #ccc",
        borderRadius: "4px",
    },
    button: {
        marginTop: "8px",
        padding: "10px",
        fontSize: "14px",
        cursor: "pointer",
        border: "none",
        borderRadius: "4px",
    },
};